import React from "react";
import ReactDOM from "react-dom";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { IOccupant } from "../../../types/ILocation";
import { useNitroStore } from "../../../store/Store";
import NitroService from "../../../utils/nitro.service";
import AddProductPanelContent from "./AddProductPanelContent";

const AddProductToDestinationPanel: React.FC = () => {
  const [
    destination,
    setExpandedDestination,
    setDisplayAddProductToDestinationPanel,
  ] = useNitroCAStore((state) => [
    state.destinationToTroubleshoot,
    state.setExpandedDestination,
    state.setDisplayAddProductToDestinationPanel,
  ]);
  const [product, setMultiLocationDestinations] = useNitroStore((state) => [
    state.product,
    state.setMultiLocationDestinations,
  ]);
  const triggerRefetchQuotes = useNitroCAStore(
    (state) => state.triggerRefetchQuotes,
  );
  const occupants = destination.details?.occupants || [];

  // close logic
  const close = () => {
    setDisplayAddProductToDestinationPanel(false);
  };

  // submit logic
  const submit = async (selected: IOccupant[]) => {
    const updatedOccupants = occupants.map((occupant) => {
      if (selected.find((o) => o.id === occupant.id)) {
        return {
          ...occupant,
          products: [...occupant.products, { product, quantity: 0 }],
        } as IOccupant;
      }
      return occupant;
    });
    await NitroService.updateOccupants({
      id: destination.id,
      occupants: updatedOccupants,
    });
    // after successfully adding product, refetch data and expand destination panel
    setMultiLocationDestinations([]);
    triggerRefetchQuotes();
    setExpandedDestination(
      {
        id: destination.id,
        name: destination.name,
      },
      {
        expandSurroundingLocations: destination.isSurroundingLocation,
      },
    );
    close();
  };

  return ReactDOM.createPortal(
    <AddProductPanelContent
      occupants={occupants}
      pinType={destination.details?.pinType || "kochAndCompetitor"}
      close={close}
      submit={submit}
    />,
    document.body,
  );
};

export default AddProductToDestinationPanel;
